(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gg-shipping-zone-selector"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const storageKey = 'gg_shipping_zone_v1';
    const validZones = ['peninsula', 'baleares', 'portugal', 'eu1'];
    const eu1Countries = ['FR', 'IT', 'BE', 'NL', 'LU'];

    const readStoredZone = () => {
      try {
        const value = window.localStorage.getItem(storageKey);
        return validZones.includes(value) ? value : '';
      } catch (error) {
        return '';
      }
    };

    const writeStoredZone = (zone) => {
      try {
        window.localStorage.setItem(storageKey, zone);
      } catch (error) {
        return;
      }
    };

    const inferredZone = (country) => {
      if (country === 'ES') return 'peninsula';
      if (country === 'PT') return 'portugal';
      if (eu1Countries.includes(country)) return 'eu1';
      return '';
    };

    const getShippingAnnouncement = () => {
      return (
        document.querySelector('.announcement-bar .slider__slide:first-child .announcement-bar__message') ||
        document.querySelector('.announcement-bar .announcement-bar__message')
      );
    };

    const init = () => {
      const root = document.querySelector('[data-gg-shipping-zone-root]');
      const dialog = document.querySelector('[data-gg-shipping-zone-dialog]');
      if (!root || !dialog) return;

      const announcement = getShippingAnnouncement();
      const messageElement = announcement ? announcement.querySelector('span') : null;
      const closeButton = dialog.querySelector('[data-gg-shipping-zone-close]');
      const options = Array.from(dialog.querySelectorAll('[data-gg-shipping-zone-option]'));

      const messages = {
        peninsula: root.dataset.messagePeninsula,
        baleares: root.dataset.messageBaleares,
        portugal: root.dataset.messagePortugal,
        eu1: root.dataset.messageEu1
      };

      const zoneLabels = {
        peninsula: root.dataset.zoneLabelPeninsula,
        baleares: root.dataset.zoneLabelBaleares,
        portugal: root.dataset.zoneLabelPortugal,
        eu1: root.dataset.zoneLabelEu1
      };

      const openDialog = () => {
        if (typeof dialog.showModal === 'function' && !dialog.open) {
          dialog.showModal();
        }
      };

      const ensureMenuTrigger = () => {
        const menuList = document.querySelector('#menu-drawer .menu-drawer__navigation > .menu-drawer__menu');
        if (!menuList) return null;

        let item = menuList.querySelector('[data-gg-shipping-zone-menu-item]');

        if (!item) {
          item = document.createElement('li');
          item.setAttribute('data-gg-shipping-zone-menu-item', 'true');

          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'menu-drawer__menu-item list-menu__item link link--text focus-inset gg-shipping-zone-menu-button';
          button.setAttribute('data-gg-shipping-zone-menu-trigger', 'true');

          const label = document.createElement('span');
          label.setAttribute('data-gg-shipping-zone-menu-label', 'true');

          const current = document.createElement('span');
          current.className = 'gg-shipping-zone-menu-current';
          current.setAttribute('data-gg-shipping-zone-menu-current', 'true');

          button.append(label, current);
          item.appendChild(button);
          menuList.appendChild(item);
        }

        return item.querySelector('[data-gg-shipping-zone-menu-trigger]');
      };

      const openFromMenu = (trigger) => {
        const drawerDetails = trigger.closest('#Details-menu-drawer-container');

        if (drawerDetails && drawerDetails.open) {
          const summary = drawerDetails.querySelector(':scope > summary');
          if (summary) {
            summary.click();
          } else {
            drawerDetails.open = false;
          }
          window.setTimeout(openDialog, 120);
          return;
        }

        openDialog();
      };

      const syncMenuTrigger = (zone) => {
        const trigger = ensureMenuTrigger();
        if (!trigger) return;

        const label = trigger.querySelector('[data-gg-shipping-zone-menu-label]');
        const current = trigger.querySelector('[data-gg-shipping-zone-menu-current]');
        const currentLabel = zone && zoneLabels[zone] ? zoneLabels[zone] : root.dataset.menuSelectLabel;

        if (label) label.textContent = root.dataset.menuLabel;
        if (current) current.textContent = currentLabel;
        trigger.setAttribute('aria-label', `${root.dataset.menuLabel}: ${currentLabel}`);

        if (trigger.dataset.ggShippingZoneBound !== 'true') {
          trigger.dataset.ggShippingZoneBound = 'true';
          trigger.addEventListener('click', () => openFromMenu(trigger));
        }
      };

      const setSelectedState = (zone) => {
        options.forEach((option) => {
          option.setAttribute('aria-pressed', option.dataset.ggShippingZoneOption === zone ? 'true' : 'false');
        });
      };

      const applyZone = (zone) => {
        if (messageElement) {
          messageElement.textContent = zone && messages[zone] ? messages[zone] : root.dataset.messageSelect;
        }
        setSelectedState(zone);
        syncMenuTrigger(zone);
      };

      const storedZone = readStoredZone();
      const suggestedZone = inferredZone((root.dataset.country || '').toUpperCase());
      const currentZone = storedZone || suggestedZone;

      applyZone(currentZone);

      if (announcement && announcement.dataset.ggShippingZoneBound !== 'true') {
        announcement.dataset.ggShippingZoneBound = 'true';
        announcement.classList.add('gg-shipping-zone-trigger');
        announcement.setAttribute('role', 'button');
        announcement.setAttribute('tabindex', '0');
        announcement.setAttribute('aria-label', root.dataset.menuLabel);

        announcement.addEventListener('click', openDialog);
        announcement.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            openDialog();
          }
        });
      }

      options.forEach((option) => {
        if (option.dataset.ggShippingZoneBound === 'true') return;
        option.dataset.ggShippingZoneBound = 'true';

        option.addEventListener('click', () => {
          const zone = option.dataset.ggShippingZoneOption;
          if (!validZones.includes(zone)) return;

          writeStoredZone(zone);
          applyZone(zone);

          if (dialog.open) {
            dialog.close();
          }
        });
      });

      if (closeButton && closeButton.dataset.ggShippingZoneBound !== 'true') {
        closeButton.dataset.ggShippingZoneBound = 'true';
        closeButton.addEventListener('click', () => {
          if (dialog.open) dialog.close();
        });
      }

      const drawerDetails = document.querySelector('#Details-menu-drawer-container');
      if (drawerDetails && drawerDetails.dataset.ggShippingZoneBound !== 'true') {
        drawerDetails.dataset.ggShippingZoneBound = 'true';
        drawerDetails.addEventListener('toggle', () => {
          if (drawerDetails.open) {
            const activeZone = readStoredZone() || inferredZone((root.dataset.country || '').toUpperCase());
            syncMenuTrigger(activeZone);
          }
        });
      }

      if (!storedZone && root.dataset.designMode !== 'true') {
        window.requestAnimationFrame(openDialog);
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gg-welcome-discount-popup"]) return;
  try {
    
  (() => {
    const initWelcomePopup = () => {
      const modal = document.querySelector('[data-gg-welcome-popup]');
      if (!modal || modal.dataset.ggInitialized === 'true') return;

      modal.dataset.ggInitialized = 'true';
      let lastFocusedElement = null;
      let previousBodyOverflow = '';

      const openPopup = () => {
        lastFocusedElement = document.activeElement;
        previousBodyOverflow = document.body.style.overflow;
        modal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';

        window.requestAnimationFrame(() => {
          const focusTarget = modal.querySelector('input, [data-gg-welcome-copy], [data-gg-welcome-close]');
          if (focusTarget) focusTarget.focus();
        });
      };

      const closePopup = () => {
        modal.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = previousBodyOverflow;
        if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
          lastFocusedElement.focus();
        }
      };

      document.addEventListener('click', (event) => {
        const trigger = event.target.closest('a[href="#gg-welcome-discount"]');
        if (trigger) {
          event.preventDefault();
          openPopup();
        }
      });

      modal.addEventListener('click', async (event) => {
        if (event.target.closest('[data-gg-welcome-close]')) {
          closePopup();
          return;
        }

        const copyButton = event.target.closest('[data-gg-welcome-copy]');
        if (!copyButton) return;

        const codeElement = modal.querySelector('[data-gg-welcome-code]');
        if (!codeElement) return;

        const code = codeElement.textContent.trim();
        try {
          await navigator.clipboard.writeText(code);
          copyButton.textContent = 'Copiado';
        } catch (error) {
          const range = document.createRange();
          range.selectNodeContents(codeElement);
          const selection = window.getSelection();
          selection.removeAllRanges();
          selection.addRange(range);
        }
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') {
          closePopup();
        }
      });

      if (window.location.hash === '#gg-welcome-discount' || modal.querySelector('[data-gg-welcome-success]')) {
        openPopup();
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initWelcomePopup, { once: true });
    } else {
      initWelcomePopup();
    }

    document.addEventListener('shopify:section:load', initWelcomePopup);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
